export type MerryMyFilesLayout = "list" | "grid";

export type MerryMyFilesPreview = "media" | "unsupported";

export type MerryMyFilesVisualState =
  | "list"
  | "list-manage"
  | "grid"
  | "grid-manage"
  | "media-detail"
  | "file-detail";

export interface MerryMyFilesVariantDefinition {
  figmaNodeId: string;
  height: number;
  width: number;
}

export type MerryMyFilesFigmaState =
  | "list"
  | "list-manage"
  | "list-selected"
  | "search"
  | "list-rename"
  | "grid"
  | "grid-manage"
  | "grid-selected"
  | "media-detail"
  | "detail-rename"
  | "file-detail";

export const merryMyFilesFigmaStates = {
  "detail-rename": "720:105227",
  "file-detail": "720:106220",
  grid: "720:100306",
  "grid-manage": "720:101665",
  "grid-selected": "720:103035",
  list: "719:105765",
  "list-manage": "719:107077",
  "list-rename": "719:112194",
  "list-selected": "719:109986",
  "media-detail": "720:107205",
  search: "719:111108",
} as const satisfies Record<MerryMyFilesFigmaState, string>;

export const merryMyFilesVisualStates = [
  "list",
  "list-manage",
  "grid",
  "grid-manage",
  "media-detail",
  "file-detail",
] as const satisfies ReadonlyArray<MerryMyFilesVisualState>;

const variantDefinitions: Record<
  MerryMyFilesVisualState,
  MerryMyFilesVariantDefinition
> = {
  list: { figmaNodeId: merryMyFilesFigmaStates.list, height: 1032, width: 560 },
  "list-manage": {
    figmaNodeId: merryMyFilesFigmaStates["list-manage"],
    height: 1032,
    width: 560,
  },
  grid: { figmaNodeId: merryMyFilesFigmaStates.grid, height: 1032, width: 560 },
  "grid-manage": {
    figmaNodeId: merryMyFilesFigmaStates["grid-manage"],
    height: 1032,
    width: 560,
  },
  "media-detail": {
    figmaNodeId: merryMyFilesFigmaStates["media-detail"],
    height: 1032,
    width: 560,
  },
  "file-detail": {
    figmaNodeId: merryMyFilesFigmaStates["file-detail"],
    height: 1032,
    width: 560,
  },
};

export function getMerryMyFilesBrowserVisualState(
  layout: MerryMyFilesLayout,
  isManaging: boolean,
): MerryMyFilesVisualState {
  if (layout === "list") return isManaging ? "list-manage" : "list";
  return isManaging ? "grid-manage" : "grid";
}

export function getMerryMyFilesDetailVisualState(
  preview: MerryMyFilesPreview,
): MerryMyFilesVisualState {
  return preview === "media" ? "media-detail" : "file-detail";
}

export function getMerryMyFilesVariant(
  state: MerryMyFilesVisualState,
): MerryMyFilesVariantDefinition {
  return variantDefinitions[state];
}

export function isMerryMyFilesVisualState(
  value: string,
): value is MerryMyFilesVisualState {
  return merryMyFilesVisualStates.some((state) => state === value);
}
